import { CSSProperties, ReactNode } from "react"
import { colors } from "../../services/config/colors"
import { Skeleton, useMediaQuery, useTheme } from "@mui/material"

const Title = ({
  children,
  fontSize = 24,
  fontWeight = 700,
  lineHeight,
  color = colors.text,
  width,
  textAlign = "left",
  paddingLeft = 0,
  paddingRight = 0,
  style,
  ellipsis = false,
  skeletonWidth = 80,
  loading,
  id,
}: {
  children?: ReactNode
  fontSize?: number
  fontWeight?: 300 | 400 | 500 | 600 | 700 | 800 | 900
  lineHeight?: string
  color?: string
  width?: string | number
  textAlign?: "left" | "center" | "right"
  paddingLeft?: number
  paddingRight?: number
  style?: CSSProperties
  ellipsis?: boolean
  skeletonWidth?: number
  loading?: boolean
  id?: string
}) => {
  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"))

  return loading ? (
    <Skeleton
      variant="text"
      style={{
        width: skeletonWidth,
        fontSize: matchesMD ? fontSize - 2 : fontSize,
        lineHeight: lineHeight,
        ...style,
      }}
    />
  ) : (
    <p
      id={id}
      style={{
        fontSize: matchesMD ? fontSize - 2 : fontSize,
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        color: color,
        maxWidth: width,
        textAlign: textAlign,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        whiteSpace: ellipsis ? "nowrap" : undefined,
        overflow: ellipsis ? "hidden" : undefined,
        textOverflow: ellipsis ? "ellipsis" : undefined,
        ...style,
      }}
    >
      {children}
    </p>
  )
}

export default Title
